module.exports = __webpack_public_path__ + "static/media/tsaska.6b2e8437.png";